import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useVideoUploaderDialog = () => {
  const store = useCreativeTemplatesBuilderStore();

  const handleOpenVideoUploaderDialog = () => store.setOpenVideoUploaderDialog(true);
  const handleCloseVideoUploaderDialog = () => store.setOpenVideoUploaderDialog(false);

  return {
    openVideoUploaderDialog: store.openVideoUploaderDialog,
    handleCloseVideoUploaderDialog,
    handleOpenVideoUploaderDialog
  };
};
